import { classicProjectFieldsEntryPoint } from '@jira/project-settings__classic-project-fields/src/classicProjectFieldsEntryPoint.entrypoint.tsx';
import { classicProjectSettingsCoreFieldsRoute } from '@jira/router-routes__classic-project-settings-fields-routes/src/classicProjectSettingsCoreFieldsRoute.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getBusinessProjectResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { licenseDetailsResource_DEPRECATED_DO_NOT_USE } from '@jira/router-resources__business-license-details/src/useIsPremiumUserSeat.tsx';
import { getNavigationSidebarProjectSettingsResource } from '@jira/router-routes__project-settings-core-entries/src/common/getNavigationSidebarProjectSettingsResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { coreProjectLayout } from '@jira/platform__layouts-core-project-layout/src/index.tsx';

import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import type { Route } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: classicProjectFieldsEntryPoint,
});
export const classicProjectSettingsCoreFieldsRouteEntry: Route = createEntry(
	classicProjectSettingsCoreFieldsRoute,
	() => ({
		group: 'project-settings-core',
		ufoName: 'project-settings.fields.core-cmp',
		layout: coreProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		canTransitionIn: () => !fg('mc-nfa-soft-rollback'),
		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...getNavigationSidebarProjectSettingsResource(),
			...getBusinessProjectResources(),
			licenseDetailsResource_DEPRECATED_DO_NOT_USE,
		],
		entryPoint: () => {
			if (fg('mc-nfa-soft-rollback')) {
				return undefined;
			}
			return pageEntryPoint;
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
		meta: {
			reporting: {
				packageName: 'jiraClassicProjectSettingsProjectFields',
				id: 'project-settings.fields.core-cmp',
				teamName: 'Yamato',
			},
		},
	}),
);
